module.exports = __webpack_public_path__ + "img/basalte_chine.9843f274.jpeg";